export default __webpack_public_path__ + "static/media/my_profile.d64f659d.svg";